import React from 'react';

const PAID_REQUESTER_ITEMS = [
  'The task is funded before a helper accepts.',
  'Only approve completion once you are satisfied.',
  'Payout is released after verification.',
  "Verified completion strengthens the helper's Action Credit.",
];

const COMMUNITY_TASK_ITEMS = [
  'No cash payout.',
  'The Community Partner verifies completion after the task is complete.',
  'Verified completion strengthens Action Credit.',
];

const PAID_HELPER_ITEMS = [
  'The requester verifies completion.',
  'Then your payout is released to your JGK Balance.',
  'Verified completion strengthens your Action Credit record.',
];

const CONFIG = {
  paidRequester: {
    title: 'How completion works',
    compact:
      'Funded first. Only approve completion once you are satisfied. Payout releases after verification.',
    items: PAID_REQUESTER_ITEMS,
  },
  paidHelper: {
    title: 'How payout works',
    compact:
      'The requester verifies completion, then your payout is released to your JGK Balance.',
    items: PAID_HELPER_ITEMS,
  },
  communityTask: {
    title: 'Community Task',
    compact:
      'No cash payout. The Community Partner verifies completion after the task is complete. Verified completion strengthens Action Credit.',
    items: COMMUNITY_TASK_ITEMS,
  },
};

export default function LocalOpsCompletionFlowHint({
  variant = 'paidRequester',
  compact = false,
  showProblemCopy = false,
  className = '',
}) {
  const config = CONFIG[variant] || CONFIG.paidRequester;
  const modifier = variant.replace(/[A-Z]/g, (match) => `-${match.toLowerCase()}`);

  return (
    <div
      className={`localops-completion-flow-hint localops-completion-flow-hint--${modifier} ${
        compact ? 'is-compact' : ''
      } ${className}`.trim()}
      data-testid={`localops-completion-flow-hint-${variant}`}
    >
      <div className="localops-completion-flow-hint__title">{config.title}</div>
      {compact ? (
        <div className="localops-completion-flow-hint__copy">
          {config.compact}
        </div>
      ) : (
        <ul className="localops-completion-flow-hint__list">
          {config.items.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      )}
      {showProblemCopy ? (
        <div className="localops-completion-flow-hint__problem">
          If something is wrong, do not approve yet.
        </div>
      ) : null}
    </div>
  );
}
